import ToggleIcon from "@assets/images/svg/toggleIcon.svg?react";
import ListIcon from "@mui/icons-material/List";
import TextFieldsIcon from "@mui/icons-material/TextFields";
import { MenuItem } from "@mui/material";
import { Editor } from "@tiptap/react";
import React, { useContext } from "react";

import { SVEditorContext } from "../../SVEditorContext";
import { useStyles } from "../styles";
import { ListItem } from "./list-item";

const featureConfig = [
  {
    title: "テキスト",
    icon: <TextFieldsIcon fontSize="small" />,
    isActive: (editor: Editor) => editor.isActive("paragraph"),
    action: (editor: Editor) => editor.chain().focus().setParagraph().run(),
  },
  {
    title: "見出し1",
    icon: "H1",
    isActive: (editor: Editor) => editor.isActive("heading", { level: 1 }),
    action: (editor: Editor) =>
      editor.chain().focus().setHeading({ level: 1 }).run(),
  },
  {
    title: "見出し2",
    icon: "H2",
    isActive: (editor: Editor) => editor.isActive("heading", { level: 2 }),
    action: (editor: Editor) =>
      editor.chain().focus().setHeading({ level: 2 }).run(),
  },
  {
    title: "見出し3",
    icon: "H3",
    isActive: (editor: Editor) => editor.isActive("heading", { level: 3 }),
    action: (editor: Editor) =>
      editor.chain().focus().setHeading({ level: 3 }).run(),
  },
  {
    title: "箇条書きリスト",
    icon: <ListIcon fontSize="small" />,
    isActive: (editor: Editor) => editor.isActive("bulletList"),
    action: (editor: Editor) => editor.chain().focus().toggleBulletList().run(),
  },
  {
    title: "トグルリスト",
    icon: <ToggleIcon width={20} height={20} />,
    isActive: () => false, // Placeholder for actual check
    action: (editor: Editor) => editor.chain().focus().setToggleList().run(),
    isOptional: true,
  },
];

export const TextGroupMenu = ({
  editor,
  handleClose,
  setFeature,
}: {
  editor: Editor | null;
  handleClose?: () => void;
  setFeature: React.Dispatch<React.SetStateAction<string>>;
}): JSX.Element => {
  const { optionalExtensions } = useContext(SVEditorContext);
  const classes = useStyles();

  // Reset logic for editor
  const resetTextGroup = (editorVal: Editor): void => {
    if (editorVal.isActive("heading")) {
      editorVal.chain().focus().setParagraph().run();
    }
    if (editorVal.isActive("bulletList")) {
      editorVal.chain().focus().toggleBulletList().run();
    }
  };

  return (
    <>
      {featureConfig
        .filter(
          (feature) => !feature.isOptional || optionalExtensions.toggleButton,
        )
        .map((feature, index) => (
          <MenuItem
            key={feature.title}
            onClick={() => {
              if (editor) {
                resetTextGroup(editor);
                feature.action(editor);
              }
              if (handleClose) {
                handleClose();
              }
              setFeature(feature.title);
            }}
            selected={editor ? feature.isActive(editor) : false}
            classes={{
              root: classes.MenuItem,
              selected: classes.MenuItemSelected,
            }}
          >
            <ListItem icon={feature.icon} primaryText={feature.title} />
          </MenuItem>
        ))}
    </>
  );
};
